import { useMemo } from 'react'

import { getTokenFromId } from '@app/services'
import { hasAccountType, isInvited } from '@app/store/user'
import { isB2BView } from '@app/utils'

import { useAuth } from './useAuth'
import { useIsStaff } from './user/useHasRole'
import { useUser } from './user/useUser'

export const useAccess = () => {
  const userState = useUser()
  const userAuthState = useAuth()
  const isStaff = useIsStaff()

  return useMemo(() => {
    const isB2B = isB2BView()

    if (isB2B && userAuthState.tokenData.urlToken && isInvited(userState)) {
      getTokenFromId()
    }

    if (isStaff) {
      return true
    }

    if (!hasAccountType(userState)('Partner')) {
      return true
    }

    return !isB2B
  }, [isStaff, userAuthState, userState])
}